"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._FuzzySearch = exports.FuzzySearch = void 0;
require("core-js/modules/es.function.name.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _2 = require("./..");
var _RadioButtonGrid = require("./RadioButtonGrid");
var _utils = require("../../../../../common/utils");
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * FuzzySearch filters data based upon the selected radio button and the text entered in
 * the search component. This component has a clear <a> tag which is used to reset the search field.
 *
 * Props:
 * title: title to display
 * name: name used to group radio buttons
 * radioBtns:  Array of button objects for filtering ({ label: <string>, value: <string>, disabled: <bool> })
 * numColumns: Integer -- number of columns in which to display the radio buttons
 * searchWidth: Integer -- (1 to 16) number of columns the search input field should span (default: 16)
 * radioSelectedValue: selected value for search radio group
 * performSearch: function to execute when radioSelectedValue changes
 * searchClear: clears input field when true  (default: false)
 * resetSearchClear: function to reset the searchClear value to be false (optional)
 * handleRadioSelection:  handler for search radio button changes
 * handleResultSelect: function to execute when item is selected from search dropdown list
 * clearAllFilters: handler for click on CLEAR anchor tag
 */
var _FuzzySearch = function _FuzzySearch(_ref) {
  var title = _ref.title,
    name = _ref.name,
    radioBtns = _ref.radioBtns,
    numColumns = _ref.numColumns,
    searchWidth = _ref.searchWidth,
    radioSelectedValue = _ref.radioSelectedValue,
    performSearch = _ref.performSearch,
    _ref$searchClear = _ref.searchClear,
    searchClear = _ref$searchClear === void 0 ? false : _ref$searchClear,
    resetSearchClear = _ref.resetSearchClear,
    handleRadioSelection = _ref.handleRadioSelection,
    handleResultSelect = _ref.handleResultSelect,
    clearAllFilters = _ref.clearAllFilters;
  var showTitleBar = title && !_lodash.default.isUndefined(clearAllFilters);
  return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
    doubling: true,
    stackable: true,
    reversed: "mobile"
  }, showTitleBar && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
    width: 16
  }, title && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Header, {
    as: "h3",
    className: "radio-header"
  }, title), !_lodash.default.isUndefined(clearAllFilters) && /*#__PURE__*/_react.default.createElement("a", {
    onClick: clearAllFilters,
    tabIndex: 0,
    role: "link"
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
    name: "undo",
    size: "small"
  }), " CLEAR")), /*#__PURE__*/_react.default.createElement(_RadioButtonGrid.RadioButtonGrid, {
    name: "".concat(name, "-radio-filter"),
    radioButtons: radioBtns,
    numColumns: numColumns,
    radioSelectedValue: radioSelectedValue,
    handleRadioSelection: handleRadioSelection
  }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
    width: searchWidth ? searchWidth : 16
  }, radioSelectedValue !== undefined && /*#__PURE__*/_react.default.createElement(_2.SearchForm, {
    disabled: radioSelectedValue === '',
    performSearch: performSearch,
    handleResultSelect: handleResultSelect,
    radioValue: radioSelectedValue,
    searchClear: searchClear,
    resetSearchClear: resetSearchClear
  })));
};
exports._FuzzySearch = _FuzzySearch;
_FuzzySearch.defaultProps = {
  radioBtns: [{
    label: '',
    value: ''
  }],
  numColumns: 1,
  radioSelectedValue: ''
};
_FuzzySearch.propTypes = {
  radioBtns: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  numColumns: _propTypes.default.number,
  radioSelectedValue: _propTypes.default.string,
  handleRadioSelection: _propTypes.default.func,
  clearAllFilters: _propTypes.default.func
};
var FuzzySearch = (0, _utils.enhance)(_FuzzySearch);
exports.FuzzySearch = FuzzySearch;